import { HiOutlineArrowRight } from "react-icons/hi";
import { Link } from "react-router-dom";

function ServiceCard(props) {
  return (
    <>
      <div className="flex flex-col justify-between p-10 mx-auto mb-10 text-center transition duration-500 ease-in-out bg-white shadow-lg rounded-xl md:hover:scale-105">
        <img
          className="mx-auto w-[100px] md:w-[125px] lg:w-[130px]"
          src={props.pic}
          alt=""
        />
        <h3 className="pt-8 pb-2 text-lg font-bold">{props.title}</h3>
        <p className="max-w-md py-2 mx-auto">{props.description}</p>
        <div className="flex justify-center mt-8">
          <Link to={props.link}>
            <button className="flex items-center text-adhocBlauw border-2 border-adhocBlauw bg rounded-[100px] px-4 py-1 font-semibold transition-all ease-in-out duration-700  hover:bg-adhocBlauw hover:text-white">
              Lees meer <HiOutlineArrowRight className="ml-2" size={20} />
            </button>
          </Link>
        </div>
      </div>
    </>
  );
}

export default ServiceCard;
